import React from 'react'
import { components } from 'react-select'

const ValueContainer = (props) => <components.ValueContainer {...props} />

export { ValueContainer }
